// Studyo Today Backend
// Package studyo.today.type
// Resource definitions
// Copyright (c) 2015-2021 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/type/time_slot.proto (package studyo.today.type, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";

/**
 * Describes the file studyo/today/type/time_slot.proto.
 */
export const file_studyo_today_type_time_slot = /*@__PURE__*/
  fileDesc("CiFzdHVkeW8vdG9kYXkvdHlwZS90aW1lX3Nsb3QucHJvdG8SEXN0dWR5by50b2RheS50eXBlInwKCFRpbWVTbG90Ei4KCnN0YXJ0X3RpbWUYASABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEiwKCGVuZF90aW1lGAIgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBISCgppc19hbGxfZGF5GAMgASgIQhmqAhZTdHVkeW8uVG9kYXkuR3JwYy5UeXBlYgZwcm90bzM", [file_google_protobuf_timestamp]);

/**
 * Describes the message studyo.today.type.TimeSlot.
 * Use `create(TimeSlotSchema)` to create a new message.
 */
export const TimeSlotSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_type_time_slot, 0);

